'use client';

import Image from 'next/image';

const BASE_PATH = '';

interface ThemeLogoProps {
  width: number;
  height: number;
  className?: string;
  /** Use native img tag instead of Next.js Image (for non-optimized contexts) */
  native?: boolean;
}

/**
 * Logo that automatically switches between dark/light variants based on theme.
 * Uses CSS dark: class — no hydration mismatch, instant switching.
 *
 * - Dark theme → logo-dark.png (light logo on dark bg)
 * - Light theme → logo-light.png (dark logo on light bg)
 */
export function ThemeLogo({ width, height, className = 'object-contain', native }: ThemeLogoProps) {
  if (native) {
    return (
      <>
        <img
          src={`${BASE_PATH}/logo-dark.png`}
          alt="Ева ИИ"
          className={`hidden dark:block ${className}`}
          style={{ width, height: 'auto' }}
        />
        <img
          src={`${BASE_PATH}/logo-light.png`}
          alt="Ева ИИ"
          className={`block dark:hidden ${className}`}
          style={{ width, height: 'auto' }}
        />
      </>
    );
  }

  return (
    <>
      <Image
        unoptimized
        src={`${BASE_PATH}/logo-dark.png`}
        alt="Ева ИИ"
        width={width}
        height={height}
        className={`hidden dark:block ${className}`}
      />
      <Image
        unoptimized
        src={`${BASE_PATH}/logo-light.png`}
        alt="Ева ИИ"
        width={width}
        height={height}
        className={`block dark:hidden ${className}`}
      />
    </>
  );
}
